import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { AppRouter } from '../../router/AppRouter';
import { PendingTakeoverProvider } from '../../contexts/PendingTakeoverContext';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from '../../queryClient';

export const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        <PendingTakeoverProvider>
          <AppRouter />
        </PendingTakeoverProvider>
      </Router>
    </QueryClientProvider>
  );
};
